import React from 'react';
import { roundNum } from 'utils/numbers';
import NutritionDataBlock from './NutritionDataBlock';

const NutritionData = props => {
  const { grams, protein, carbs, fat, calories } = props;

  return (
    <div className="nutrition-data">
      {grams && <NutritionDataBlock value={`${roundNum(grams)}g`} label="Grams" />}
      <NutritionDataBlock value={`${roundNum(protein)}g`} label="Protein" />
      <NutritionDataBlock value={`${roundNum(carbs)}g`} label="Carbs" />
      <NutritionDataBlock value={`${roundNum(fat)}g`} label="Fats" />
      <NutritionDataBlock value={`${roundNum(calories)}g`} label="Calories" />
    </div>
  );
};

export default NutritionData;
